export default "__VITE_ASSET__C3IrAZaU__"